/* Ritual Organics: one-item upsell in the add-to-cart popup.
   Markup, product data and styles live in snippets/ritual-cart-upsell.liquid. */
(() => {
  const box = document.getElementById('ro-upsell');
  const dataEl = document.getElementById('ro-upsell-data');
  const popup = document.getElementById('cart-notification');
  if (!box || !dataEl || !popup) return;
  const D = JSON.parse(dataEl.textContent);
  const money = (c) => '$' + (c / 100).toFixed(2);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let wasOpen = false;

  const shipLine = (cart, offerPrice, offerIsMerch, hasMerch) => {
    const before = cart.total_price;
    const after = before + offerPrice;
    // Balm-only orders already ship free, so a shipping line only matters once merch is involved.
    if (!hasMerch && !offerIsMerch) return '';
    if (before < D.threshold && after >= D.threshold) return 'Add it and your whole order ships free.';
    if (after >= D.threshold) return 'Ships free with your order.';
    return `You'll be ${money(D.threshold - after)} from free shipping.`;
  };

  const renderOffer = (cart, kind, hasMerch) => {
    const caps = D.caps.filter((c) => c.available && c.variant);
    const options = kind === 'cap' ? caps : [D.balm];
    if (!options.length || !options[0].variant || !options[0].available) { box.hidden = true; return; }
    let pick = options[0];

    box.innerHTML = `
      <p class="ro-upsell__eyebrow">${kind === 'cap' ? 'Pairs with your balm' : 'Bring the balm'}</p>
      <div class="ro-upsell__row">
        <div class="ro-upsell__img"><img alt="" data-u-img></div>
        <div class="ro-upsell__info">
          <p class="ro-upsell__title" data-u-title></p>
          <p class="ro-upsell__blurb" data-u-blurb></p>
          <p class="ro-upsell__price" data-u-price></p>
        </div>
      </div>
      ${options.length > 1 ? `<div class="ro-upsell__toggle">${options.map((o, i) => `<button type="button" data-u-opt="${i}" class="${i === 0 ? 'is-on' : ''}">${o.label}</button>`).join('')}</div>` : ''}
      <button type="button" class="ro-upsell__add" data-u-add></button>
      <p class="ro-upsell__ship" data-u-ship></p>`;

    const paint = () => {
      box.querySelector('[data-u-img]').src = pick.image;
      box.querySelector('[data-u-title]').textContent = pick.label ? `${pick.title}, ${pick.label}` : pick.title;
      box.querySelector('[data-u-blurb]').textContent = pick.blurb;
      box.querySelector('[data-u-price]').textContent = money(pick.price);
      box.querySelector('[data-u-add]').textContent = `Add for ${money(pick.price)}`;
      box.querySelector('[data-u-ship]').textContent = shipLine(cart, pick.price, kind === 'cap', hasMerch);
    };
    box.querySelectorAll('[data-u-opt]').forEach((b) => b.addEventListener('click', (e) => {
      e.stopPropagation();
      box.querySelectorAll('[data-u-opt]').forEach((x) => x.classList.remove('is-on'));
      b.classList.add('is-on');
      pick = options[+b.dataset.uOpt];
      paint();
    }));
    box.querySelector('[data-u-add]').addEventListener('click', async (e) => {
      e.stopPropagation();
      const btn = e.currentTarget;
      btn.disabled = true; btn.textContent = 'Adding...';
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: pick.variant, quantity: 1 }], sections: 'cart-icon-bubble,cart-notification-button', sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'Could not add it');
        const swap = (id) => {
          const el = document.getElementById(id);
          if (!el || !data.sections || !data.sections[id]) return;
          const doc = new DOMParser().parseFromString(data.sections[id], 'text/html');
          const src = doc.getElementById(id) || doc.querySelector('.shopify-section');
          if (src) el.innerHTML = src.innerHTML;
        };
        swap('cart-icon-bubble'); swap('cart-notification-button');
        const cartNow = await fetch(root + 'cart.js').then((r) => r.json());
        const free = cartNow.total_price >= D.threshold;
        box.innerHTML = `<p class="ro-upsell__done">Added. ${free ? 'Your order ships free.' : ''}</p>`;
      } catch (err) {
        btn.disabled = false; paint();
        box.querySelector('[data-u-ship]').textContent = err.message;
      }
    });
    paint();
    box.hidden = false;
  };

  const renderNote = (cart) => {
    box.innerHTML = `<p class="ro-upsell__done">You're ${money(D.threshold - cart.total_price)} from free shipping.</p>`;
    box.hidden = false;
  };

  const run = async () => {
    box.hidden = true;
    let cart;
    try { cart = await fetch(root + 'cart.js').then((r) => r.json()); } catch (e) { return; }
    const handles = cart.items.map((i) => i.handle);
    const hasBalm = handles.some((h) => D.balmHandles.includes(h));
    const hasCap = handles.some((h) => D.capHandles.includes(h));
    const hasMerch = cart.items.some((i) => i.vendor === 'Printify' || i.product_type === 'Kit' || D.merchHandles.includes(i.handle));
    if (hasBalm && !hasCap) return renderOffer(cart, 'cap', hasMerch);
    if (hasMerch && !hasBalm) return renderOffer(cart, 'balm', hasMerch);
    if (hasMerch && cart.total_price < D.threshold) return renderNote(cart);
  };

  new MutationObserver(() => {
    const open = popup.classList.contains('active');
    if (open && !wasOpen) run();
    wasOpen = open;
  }).observe(popup, { attributes: true, attributeFilter: ['class'] });
})();
